
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"d":"M24 14.1c0-.1-4.8-6.3-11.7-6.3S.8 14 .8 14.1l-.8-.6c.1-.3 5.1-6.6 12.5-6.6s12.2 6.3 12.5 6.6l-1 .6zm-6.6 2.5c0-2.8-2.2-4.9-5.1-4.9s-5 2.2-5 4.9 2.4 4.9 5.2 4.9h0c2.7.1 4.9-2.1 4.9-4.9zm-.8 0c0 2.2-1.8 4.1-4.1 4.1s-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1h0c2.2 0 4.1 1.9 4.1 4.1z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff","stroke":"1"}})])
          )
        }
      }
    